import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Icons,
} from '../../../components/base/BootstrapComponents';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import TextInput from '../../../components/fields/TextInput/TextInput';
import ParkingMeterDTO from '../../../dto/ParkingMeterDTO';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import { optionClassFormatter } from '../../../utils/formatters';
import { lowDoorKeys, metricKeys, PARKING_METER_STATUS } from '../constants';
import { getParkingMetersData } from '../reducer';
import { loadHostList, loadHostStatusesList, historyExportWord } from '../actions';
import {
  getPaginationOpts, responseLogWithNotification, saveFilter,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { convertMetricFilters, sortByStatus } from '../parking-meter-utils';
import MobileParkingMeterFilter from './MobileParkingMeterFilter';
import MobileParkingMeterGrid from './MobileParkingMeterGrid';
import MobileParkingMeterHistoryPopup from './MobileParkingMeterHistoryPopup';
import MobileParkingMeterMap from './MobileParkingMeterMap';
import MobileParkingMeterMatrix from './MobileParkingMeterMatrix';
import MatrixReportPopup from './MatrixReportPopup';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import RadioList from '../../../components/fields/CheckBoxInput/RadioList';

const tabOptions = [
  { value: 0, label: 'Таблица' },
  { value: 1, label: 'Карта' },
  { value: 2, label: 'Матрица' },
];

export default function MobileParkingMetersPage() {
  const {
    loadingHostComponents,
    loadingHostList,
    hostList,
    hostListMeta,
    showHistoryPopup,
    currentParkingMeter,
    loadingHostCommandDispatch,
    loadingHostStatusesList,
    hostStatusesList,
    hostStatusesListMeta,
    loadingHostDetail,
    hostDetail,
    loadingHistoryExportWord,
    zones,
    loadingZones,
  } = useSelector(getParkingMetersData);
  const dispatch = useDispatch();
  const handleLoadingHostList = opts => {
    const filterData = getValues();
    if (opts && !opts.page) {
      opts.page = 1;
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    saveFilter(filterData, 'parking-meter-filter');
    if (filterData) {
      convertMetricFilters(filterData);
    }
    const paginationOpts = getPaginationOpts(hostListMeta, opts);
    const requestData = { metricKeys, ...paginationOpts, filter: filterData };
    const action = !selectedTab || !selectedTab.value
      ? loadHostList
      : loadHostStatusesList;
    if (currentTimeOut) {
      clearTimeout(currentTimeOut);
    }
    if (window.location.pathname === '/parking-meters') {
      dispatch(action(requestData)).catch(responseLogWithNotification).finally(() => {
        if (updatePeriod && selectedTab) {
          const t = setTimeout(() => handleLoadingHostList(opts), updatePeriod * 1000);
          clearTimeout(window.parkingMetreTimeOut);
          window.parkingMetreTimeOut = t;
        }
        setShowContent(true);
      // setOpenFilter(false);
      });
    }
  };
  const [selectedTab, setTab] = useState(tabOptions[0]);
  const [selectedHost, setHost] = useState(null);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [fullScreen, setFullScreenMap] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [zoom, setZoom] = useState(10);
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const [showMatrixReport, setShowMatrixReport] = useState(false);
  const [isCenter, setIsCenter] = useState(false);
  const isInitialMount = useRef(true);
  const defaultValues = {
    query: '',
    host: '',
    status: 0,
    address: '',
    zbx_zone: '',
    update_period: 0,
    available_status: 0,
    DOOR_LOWER_UNKNOWN: false,
    DOOR_LOWER_OPENED: false,
    DOOR_LOWER_CLOSED: false,
    DOOR_UPPER_UNKNOWN: false,
    DOOR_UPPER_OPENED: false,
    DOOR_UPPER_CLOSED: false,
    DOOR_LOCK_LOWER_ERROR: false,
    DOOR_LOCK_LOWER_UNKNOWN: false,
    DOOR_LOCK_LOWER_LOCKED: false,
    DOOR_LOCK_LOWER_UNLOCKED_CLOSED: false,
    DOOR_LOCK_LOWER_UNLOCKED_OPENED: false,
    DOOR_LOCK_UPPER_ERROR: false,
    DOOR_LOCK_UPPER_UNKNOWN: false,
    DOOR_LOCK_UPPER_LOCKED: false,
    DOOR_LOCK_UPPER_UNLOCKED_CLOSED: false,
    DOOR_LOCK_UPPER_UNLOCKED_OPENED: false,
    PSS_ERROR: false,
    PSS_UNKNOWN: false,
    PSS_UNREGISTERED: false,
    PSS_OK: false,
    PS_ERROR: false,
    PS_PAPER_EMPTY: false,
    PS_PAPER_LOW: false,
    PS_UNKNOWN: false,
    PS_OK: false,
    POWER_ERROR: false,
    POWER_LOW_POWER: false,
    POWER_UNKNOWN: false,
    POWER_OK: false,
    PAYMENT_ERROR: false,
    PAYMENT_UNKNOWN: false,
    PAYMENT_IDLE: false,
    PAYMENT_WAIT_CARD: false,
    PAYMENT_WAIT_BANK: false,
    PAYMENT_COMPLETE: false,
  };
  const {
    register, watch, getValues, setValue, reset, resetField,
  } = useForm({
    defaultValues: { ...defaultValues, ...(JSON.parse(localStorage.getItem('parking-meter-filter')) || {}) },
  });
  const formData = getValues();
  watch();
  useEffect(() => {
    const subscription = watch(value => {
      if (!getValues('update_period')) {
        setUpdatePeriod(0);
      }
      if (isOpenFilter) {
        handleLoadingHostList();
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const statusOptions = Object.values(PARKING_METER_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.status.${v}` })).reverse();
  const DTO = new ParkingMeterDTO();
  const attributes = DTO.getAttributesByName();
  const triggerFullScreen = value => setFullScreenMap(value);
  const [updatePeriod, setUpdatePeriod] = useState(0 || getValues('update_period'));
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      handleLoadingHostList();
      return () => { clearTimeout(window.parkingMetreTimeOut); };
    }
  }, [selectedTab, updatePeriod]);
  const changeUpdatePeriod = value => {
    setUpdatePeriod(value || 0);
  };
  const sortedHostStatusesList = hostStatusesList.sort(sortByStatus);

  const showOnMap = item => {
    setTab(tabOptions[1]);
    setHost(item);
  };
  const selectedStatus = statusOptions.find(i => i.value === Number(getValues('status')));
  return (
    <div className={classNames('parking-meters-page content g-0', { 'page-with-map-fullscreen': fullScreen })} id="parking-meter-scroll-block-1">
      <Loader global loading={loadingZones || loadingHostList || loadingHostComponents || loadingHostCommandDispatch || loadingHostStatusesList || loadingHostDetail || loadingHistoryExportWord} />
      {showContent
        ? (
          <div className="mobile-parking-meters-content">
            <TabMenu
              selectedTab={selectedTab}
              options={tabOptions}
              onSelectOptions={item => { setTab(item); setHost(null); }}
            />
            <PageHeader className="mobile-page-header" header="Информация о парковочном оборудовании">
              <Icons width={14} height={14} customIcon icon="filter" className="show-filter-button" onClick={() => { setOpenFilter(true); setHost(null); }} />
            </PageHeader>
            {selectedTab && selectedTab.value === 0 ? <MobileParkingMeterGrid loading={loadingHostList} showOnMap={showOnMap} hostList={hostList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} /> : null}
            {selectedTab && selectedTab.value === 1 && window.yandexMap ? <MobileParkingMeterMap setHost={setHost} selectedHost={selectedHost} hostDetail={hostDetail} triggerFullScreen={triggerFullScreen} hostStatusesList={hostStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} zoom={zoom} setZoom={setZoom} isCenter={isCenter} setIsCenter={setIsCenter} /> : null}
            {selectedTab && selectedTab.value === 2 ? <MobileParkingMeterMatrix hostDetail={hostDetail} hostStatusesList={hostStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} createReport={() => setShowMatrixReport(true)} /> : null}
            {showHistoryPopup && currentParkingMeter ? <MobileParkingMeterHistoryPopup key={currentParkingMeter && currentParkingMeter.id ? currentParkingMeter.id : ''} /> : null}
            {showMatrixReport && sortedHostStatusesList ? <MatrixReportPopup sortedHostStatusesList={sortedHostStatusesList} handleClose={() => setShowMatrixReport(false)} /> : null}
          </div>
        )
        : (
          <div className="mobile-parking-meters-filter">
            <PageHeader className="mobile-page-header" header="Информация о парковочном оборудовании" />
            <div className="mpm-filter-button">
              <span onClick={() => setOpenFilter(true)}>Все фильтры</span>
            </div>
            <FieldWithAttributeDTO
              type="text"
              component={TextInput}
              withLabel
              dtoObject={{
                name: 'query',
                type: String,
                validators: [],
                labelKey: 'search',
              }}
              inputProps={{
                ...register('query', { maxLength: 30 }),
                value: getValues('query'),
              }}
              className="search-field"
              variant="material"
            />
            <FieldWithAttributeDTO
              type="text"
              component={TextInput}
              dtoObject={attributes.host}
              withLabel
              inputProps={{
                ...register('host'),
                value: getValues('host'),
              }}
              className="host-filter"
              variant="material"
            />

            <RadioList label="Состояние" selectedValue={selectedStatus} clearFilter={() => reset({ ...getValues(), status: 0 })}>
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={statusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('status'),
                  value: Number(getValues('status')),
                  onChange: e => {
                    setValue('status', Number(e.target.value));
                  },
                }}
              />
            </RadioList>
            <Button className="mpm-filter-show-list-button big" onClick={handleLoadingHostList}>Показать</Button>
          </div>
        )}

      {isOpenFilter ? (
        <MobileParkingMeterFilter
          handleLoadingHostList={handleLoadingHostList}
          changeUpdatePeriod={changeUpdatePeriod}
          updatePeriod={updatePeriod}
          meta={!selectedTab || !selectedTab.value ? hostListMeta : hostStatusesListMeta}
          reset={reset}
          onHide={() => { setOpenFilter(false); }}
          register={register}
          getValues={getValues}
          setValue={setValue}
          resetField={resetField}
          zones={zones}
          defaultValues={defaultValues}
        />
      )
        : null}
    </div>
  );
}
